export default __webpack_public_path__ + "static/media/settings.fb4c8478.svg";